import React, { useState, useEffect } from 'react'
import Sidebar from '../mini-comp/Sidebar'
import Topbar from '../mini-comp/Topbar'
import axios from 'axios';
import Cookies from 'js-cookie';
import API_BASE_URL from '../../../config/api';
import Swal from 'sweetalert2';
import { RiEyeLine, RiEditLine, RiDeleteBinLine } from 'react-icons/ri';

const Modules = () => {
    const [modules, setModules] = useState([]);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        description: ''
    });

    const fetchModules = () => {
        const token = Cookies.get('token');
        if (!token) {
            console.error('No token found in cookies');
            setLoading(false);
            return;
        }

        axios.get(`${API_BASE_URL}/api/v1/billing/modules/`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(response => {
                console.log('Modules response:', response.data);
                // Handle different response structures
                const modulesData = response.data.modules || response.data || [];
                setModules(Array.isArray(modulesData) ? modulesData : []);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching modules:', error);
                setLoading(false);
            });
    };

    const handleInputChange = (e) => {
        const { id, name, value } = e.target;
        const fieldName = name || id;
        setFormData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        const token = Cookies.get('token');
        if (!token) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'No token found in cookies'
            });
            setSubmitting(false);
            return;
        }

        try {
            const response = await axios.post(
                `${API_BASE_URL}/api/v1/billing/modules/`,
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                }
            );

            console.log('Module created successfully:', response.data);

            // Close modal
            const modal = document.getElementById('addNewModule');
            if (modal) {
                const bsModal = window.bootstrap?.Modal?.getInstance(modal);
                if (bsModal) {
                    bsModal.hide();
                } else {
                    modal.classList.remove('show');
                    modal.style.display = 'none';
                    document.body.classList.remove('modal-open');
                    const backdrop = document.querySelector('.modal-backdrop');
                    if (backdrop) backdrop.remove();
                }
            }

            // Reset form
            setFormData({
                name: '',
                code: '',
                description: ''
            });

            // Refresh modules list
            fetchModules();

            setSubmitting(false);
            Swal.fire({
                icon: 'success',
                title: 'Success!',
                text: 'Module created successfully!',
                timer: 2000,
                showConfirmButton: false
            });
        } catch (error) {
            console.error('Error creating module:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.response?.data?.message || 'Failed to create module. Please try again.'
            });
            setSubmitting(false);
        }
    };

    useEffect(() => {
        fetchModules();
    }, []);

    return (
        <div>
            <Topbar />
            <Sidebar />

            <>{ /* app-content-area-start */}
                <div className="app-content-area">
                    <div className="app-content-wrap">
                        <div className="container-fluid">
                            <div className="row fix">
                                <div className="col-xxl-12 col-xl-12 col-lg-12">
                                    <div className="card mb-4">
                                        <div className="card-header justify-between">
                                            <h4 className="d-flex-items gap-10">Modules<span className="badge bg-label-primary">{modules.length}</span></h4>
                                            <div className="d-flex flex-wrap gap-15">
                                                <button type="button" className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addNewModule">
                                                    Add Module
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    {loading ? (
                                        <div className="text-center py-5">
                                            <span className="text-muted">Loading modules...</span>
                                        </div>
                                    ) : modules && modules.length > 0 ? (
                                        <div className="row">
                                            {modules.map((module) => (
                                                <div key={module.id || module.module_id} className="col-xxl-3 col-xl-4 col-lg-4 col-md-4 mb-4">
                                                    <div className="product-card">
                                                        <div className="product-thumbs">

                                                            <ul className="product-action-btn">
                                                                <li>
                                                                    <a
                                                                        href={`/admin/module/${module.id || module.module_id}`}
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        data-bs-title="View Details"
                                                                    >
                                                                        <i className="ri-eye-line" />
                                                                    </a>
                                                                </li>
                                                                <li>
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        data-bs-toggle="tooltip"
                                                                        data-bs-placement="top"
                                                                        data-bs-title="Edit Module"
                                                                    >
                                                                        <i className="ri-edit-line" />
                                                                    </a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        <div className="product-content">
                                                            <h5 className="mb-5 underline">
                                                                <a href={`/admin/module/${module.id || module.module_id}`}>
                                                                    {module.name || module.module_name || 'Unnamed Module'}
                                                                </a>
                                                            </h5>
                                                            <p className="mb-2">
                                                                {module.description || module.desc || 'No description available'}
                                                            </p>
                                                            {module.price && (
                                                                <p className="price">
                                                                    ${module.price}
                                                                    {module.old_price && (
                                                                        <span className="old-price">${module.old_price}</span>
                                                                    )}
                                                                </p>
                                                            )}
                                                            {module.status && (
                                                                <span className={`badge ${module.status === 'active' || module.status === 'Active' ? 'bg-label-success' : 'bg-label-danger'}`}>
                                                                    {module.status}
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-5">
                                            <span className="text-muted">No modules found</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* start create module modal */}
                <div
                    className="modal fade"
                    id="addNewModule"
                    tabIndex={-1}
                    aria-labelledby="addNewModuleLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <form onSubmit={handleSubmit}>
                                <div className="modal-header">
                                    <h1
                                        className="modal-title fs-16"
                                        id="addNewModuleLabel"
                                    >
                                        Add New Module
                                    </h1>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        data-bs-dismiss="modal"
                                        aria-label="Close"
                                    />
                                </div>
                                <div className="modal-body">
                                    <div className="row gy-15">
                                        <div className="col-xl-6">
                                            <label htmlFor="name" className="form-label">
                                                Module Name <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                name="name"
                                                placeholder="Module Name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-xl-6">
                                            <label htmlFor="code" className="form-label">
                                                Module Code <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="code"
                                                name="code"
                                                placeholder="Module Code"
                                                value={formData.code}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                        <div className="col-xl-12">
                                            <label htmlFor="description" className="form-label">
                                                Description <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                id="description"
                                                name="description"
                                                placeholder="Module Description"
                                                rows="4"
                                                value={formData.description}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-danger"
                                        data-bs-dismiss="modal"
                                        disabled={submitting}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        disabled={submitting}
                                    >
                                        {submitting ? 'Creating...' : 'Create Module'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* end create module modal */}
                { /* app-content-area-end */}</>
        </div>
    )
}

export default Modules